import { render } from "./TreeVineSpacingInput.vue?vue&type=template&id=ef0e4b78&scoped=true"
import script from "./TreeVineSpacingInput.vue?vue&type=script&lang=js"
export * from "./TreeVineSpacingInput.vue?vue&type=script&lang=js"

import "./TreeVineSpacingInput.vue?vue&type=style&index=0&id=ef0e4b78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef0e4b78"]])

export default __exports__